export default [
  {
    path: 'feedbacks',
    name: 'auth.feedback.list',
    component: () => import(/* webpackChunkName: "admin-general" */ '../../views/admin/user/FeedbackList')
  }
]
